// chapterUtils.ts - Runtime functions for chapter management
import type { Chapter, ChapterVersion } from '../types/core';

export const getActiveVersion = (chapter: Chapter | null | undefined): ChapterVersion | null => {
    if (!chapter || !Array.isArray(chapter.history) || chapter.history.length === 0 || typeof chapter.historyIndex !== 'number' || chapter.historyIndex < 0 || chapter.historyIndex >= chapter.history.length) {
        return null;
    }
    return chapter.history[chapter.historyIndex];
};